module.exports = __webpack_public_path__ + "img/Gerald Allen.e20f1266.jpg";